import { LANGUAGE_CODE, LANGUAGE_NAME_TRANSLATED, LANGUAGE_TRANSLATED } from '../constant/language';
import { getKeyDisplayName } from './index';

export const getLanguageName = (languageCode: string) => {
  const code: string = languageCode ? languageCode : LANGUAGE_CODE.ENGLISH;
  return getKeyDisplayName(LANGUAGE_CODE, code);
};

export const getLanguageNameTranslated = (languageCode: string) => {
  const code: string = languageCode ? languageCode : LANGUAGE_CODE.ENGLISH;
  return LANGUAGE_NAME_TRANSLATED[code];
};

export const getLanguageTranslated = (languageCode: string) => {
  const code: string = languageCode ? languageCode : LANGUAGE_CODE.ENGLISH;
  return LANGUAGE_TRANSLATED[code];
};

export const getIsRtl = (languageCode: string) => {
  return languageCode === LANGUAGE_CODE.ARABIC
      || languageCode === LANGUAGE_CODE.HEBREW
      || languageCode === LANGUAGE_CODE.PERSIAN
      ;
};
